








import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import L from 'leaflet'

// Helpers
import { parseBase64 } from '@/helpers/image'

@Component
export default class PhotoMap extends Vue {
  imageSrc: string = null
  isLoading = false
  map = null

  img = new Image()
  bounds = null

  @Prop({ type: Object }) data !: { value: string, annotations: [any], id: number }
  @Getter('token') token
  @Getter('orientation', { namespace: 'report' }) orientation: string

  async mounted() {
    await this.loadImage()
  }


  mapLoaded() {
    const overlay = L.imageOverlay(this.img, this.bounds).addTo(this.map)
    this.map.fitBounds(this.bounds)

    for (const [index, annotation] of this.data.annotations.entries()) {

      const topMiddle = this.map.unproject(
        [annotation.left + (annotation.width / 2), annotation.top],
        this.map.getMaxZoom())

      const topLeft = this.map.unproject(
        [annotation.left, annotation.top],
        this.map.getMaxZoom())
      const topRight = this.map.unproject(
        [annotation.left + annotation.width, annotation.top],
        this.map.getMaxZoom())
      const bottomLeft = this.map.unproject(
        [annotation.left, annotation.top + annotation.height],
        this.map.getMaxZoom())
      const bottomRight = this.map.unproject(
        [annotation.left + annotation.width, annotation.top + annotation.height],
        this.map.getMaxZoom())

      const rectangle = new L.rectangle([
        [ topLeft, bottomLeft], [topRight, bottomRight ]], { color: '#ff2d55', fillOpacity: 0 }).addTo(this.map)

      const icon = L.divIcon({
        className: 'annotation-index',
        html: `<div class="annotation-marker"><span class="tag is-rounded is-danger">${annotation.index}</span></div>`
      })

      const choice = this.$t(`global.report.annotation.choice.${annotation.choice}`)
      const description = annotation.description

      const tipIcon = L.divIcon({
        class: 'annotation-tooltip',
        html: `<span>${choice}</span><span>${description}</span>`
      })

      const marker = L.marker(topMiddle, { icon }).addTo(this.map)

      const legend = annotation.description ?
      this.$t(`global.report.annotation.choice.${annotation.choice}`) + ` - "${annotation.description}"` :
      this.$t(`global.report.annotation.choice.${annotation.choice}`)

      rectangle.bindTooltip(
        legend,
        {
          className: 'annotation-tooltip',
          sticky: true,
          direction: 'left'
        }
      )

    }
  }

  beforeDestroy() {
    if (this.map) {
      this.map.remove()
    }
  }

  async loadImage() {
    if (!this.data && !this.data.value) {
      return
    }
    try {
      this.isLoading = true
      const res = await this.$api.image.getImageFromHash(this.token, this.data.value, false)

      this.img.onload = () => {
        this.map = L.map(`map-image-${this.data.id}`, {
          zoom: 1,
          minZoom: 1,
          maxZoom: 4,
          center: [(this.img.naturalHeight / 2), (this.img.naturalWidth / 2)],
          crs: L.CRS.Simple
        })

        // calculate the edges of the image, in coordinate space
        const southWest = this.map.unproject([0, this.img.naturalHeight], this.map.getMaxZoom())
        const northEast = this.map.unproject([this.img.naturalWidth, 0], this.map.getMaxZoom())
        this.bounds = new L.LatLngBounds(southWest, northEast)

        this.map.zoomControl.setPosition('topright')
        this.map.setMaxBounds(this.bounds)

        this.map.on('load', this.mapLoaded())
      }

      this.img.src = parseBase64(res.data)
    } finally {
      this.isLoading = false
    }
  }
}
